/* Prime Archive – theme.js */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const T = window.theme || { routes: {}, strings: {} };

  const store = {
    get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* egal */ } }
  };

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------- Drawer ---------- */
  let lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.body.classList.add('is-locked');
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-open')));
    const f = el.querySelector('button, a, input');
    if (f) setTimeout(() => f.focus({ preventScroll: true }), 50);
  }
  function closeDrawer(el) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    setTimeout(() => { el.hidden = true; }, 350);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-open-menu]')) { e.preventDefault(); openDrawer($('#MenuDrawer')); return; }
    if (t.closest('[data-open-cart]') && T.cartDrawer && $('#CartDrawer')) { e.preventDefault(); openDrawer($('#CartDrawer')); return; }
    if (t.closest('[data-close-drawer]')) { closeDrawer(t.closest('.drawer')); return; }
    if (t.closest('[data-open-search]')) { openSearch(); return; }
    if (t.closest('[data-close-search]')) { closeSearch(); return; }
    const copy = t.closest('[data-copy]');
    if (copy) {
      const code = copy.dataset.copy;
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(() => toast('✓ ' + code), () => {});
    }
    const share = t.closest('[data-share]');
    if (share) {
      if (navigator.share) navigator.share({ title: share.dataset.title, url: share.dataset.url }).catch(() => {});
      else if (navigator.clipboard) navigator.clipboard.writeText(share.dataset.url).then(() => toast('Link ✓'));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    closeSearch();
    closePopup();
  });

  /* Dropdowns per Tastatur / Touch */
  $$('.has-dropdown > .nav__link').forEach((btn) => {
    btn.addEventListener('click', () => {
      const li = btn.parentElement;
      const open = !li.classList.contains('is-open');
      $$('.has-dropdown.is-open').forEach((x) => { x.classList.remove('is-open'); x.firstElementChild.setAttribute('aria-expanded', 'false'); });
      li.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.has-dropdown')) $$('.has-dropdown.is-open').forEach((x) => x.classList.remove('is-open'));
  });

  /* ---------- Warenkorb ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  }

  function renderCartDrawer(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#CartDrawer .drawer__panel');
    const current = $('#CartDrawer .drawer__panel');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  async function refreshCount() {
    try {
      const r = await fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } });
      const c = await r.json();
      updateCount(c.item_count);
    } catch (e) { /* egal */ }
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.js-add-form');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    const fd = new FormData(form);
    const body = { items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }], sections: 'cart-drawer', sections_url: window.location.pathname };
    try {
      const r = await fetch(T.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await r.json();
      if (!r.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      if (data.sections) renderCartDrawer(data.sections['cart-drawer']);
      await refreshCount();
      if (btn) { btn.classList.add('is-added'); setTimeout(() => btn.classList.remove('is-added'), 1600); }
      if (T.cartDrawer && $('#CartDrawer')) openDrawer($('#CartDrawer'));
      else toast('✓ ' + T.strings.added);
    } catch (err) {
      toast(err.message || T.strings.error);
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  });

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('#CartDrawer [data-qty-change]');
    if (!b) return;
    const panel = $('#CartDrawer .cart-drawer');
    if (panel) panel.classList.add('is-loading');
    try {
      const r = await fetch(T.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(b.dataset.line), quantity: Number(b.dataset.qtyChange), sections: 'cart-drawer', sections_url: window.location.pathname })
      });
      const data = await r.json();
      if (data.status) throw new Error(data.description || data.message);
      if (data.sections) renderCartDrawer(data.sections['cart-drawer']);
      updateCount(data.item_count);
    } catch (err) {
      toast(err.message || T.strings.error);
    } finally {
      const p = $('#CartDrawer .cart-drawer');
      if (p) p.classList.remove('is-loading');
    }
  });

  /* ---------- Suche ---------- */
  function openSearch() {
    const el = $('#SearchOverlay');
    if (!el) return;
    el.hidden = false;
    document.body.classList.add('is-locked');
    setTimeout(() => $('#SearchInput') && $('#SearchInput').focus(), 30);
  }
  function closeSearch() {
    const el = $('#SearchOverlay');
    if (!el || el.hidden) return;
    el.hidden = true;
    document.body.classList.remove('is-locked');
  }
  const sInput = $('#SearchInput');
  const sResults = $('#SearchResults');
  let sTimer, sCtrl;
  if (sInput && sResults) {
    sInput.addEventListener('input', () => {
      clearTimeout(sTimer);
      const q = sInput.value.trim();
      if (q.length < 2) { sResults.innerHTML = ''; return; }
      sTimer = setTimeout(async () => {
        if (sCtrl) sCtrl.abort();
        sCtrl = new AbortController();
        try {
          const url = T.routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
          const r = await fetch(url, { signal: sCtrl.signal });
          const d = await r.json();
          const items = (d.resources && d.resources.results && d.resources.results.products) || [];
          if (!items.length) { sResults.innerHTML = '<p class="empty">' + T.strings.noResults + '</p>'; return; }
          const money = (p) => new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(Number(p));
          sResults.innerHTML = items.map((p) => {
            const img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + (p.featured_image.url.includes('?') ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '<span></span>';
            return '<a class="s-result' + (p.available ? '' : ' is-soldout') + '" href="' + p.url + '">' + img + '<span class="s-result__title">' + p.title + '</span><span class="s-result__price">' + (p.available ? money(p.price) : T.strings.soldOut) + '</span></a>';
          }).join('') + '<a class="s-all" href="' + T.routes.search + '?type=product&q=' + encodeURIComponent(q) + '">' + T.strings.viewAll + ' →</a>';
        } catch (e) { /* abgebrochen */ }
      }, 220);
    });
  }

  /* ---------- Slider ---------- */
  $$('[data-slider]').forEach((root) => {
    const track = $('[data-slider-track]', root);
    if (!track) return;
    const slides = $$('.slider__slide', track);
    const cur = $('[data-slider-current]', root);
    const tot = $('[data-slider-total]', root);
    if (tot) tot.textContent = slides.length;
    const step = () => (slides[0] ? slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 12) : 300);
    $('[data-slider-prev]', root) && $('[data-slider-prev]', root).addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
    $('[data-slider-next]', root) && $('[data-slider-next]', root).addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
    track.addEventListener('scroll', () => {
      if (!cur) return;
      const i = Math.round(track.scrollLeft / step()) + 1;
      cur.textContent = Math.min(Math.max(i, 1), slides.length);
    }, { passive: true });
  });

  /* ---------- Drag-Scroll (Highlights) ---------- */
  $$('[data-drag-scroll]').forEach((el) => {
    let down = false, startX = 0, startL = 0, moved = false;
    el.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startL = el.scrollLeft;
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 5) { moved = true; el.classList.add('is-dragging'); }
      el.scrollLeft = startL - dx;
    });
    window.addEventListener('pointerup', () => { down = false; el.classList.remove('is-dragging'); });
    el.addEventListener('click', (e) => { if (moved) { e.preventDefault(); moved = false; } }, true);
    const current = el.querySelector('.is-current');
    if (current) el.scrollLeft = current.closest('.highlight').offsetLeft - el.clientWidth / 2 + current.clientWidth / 2;
  });

  /* ---------- Countdown ---------- */
  $$('[data-countdown]').forEach((el) => {
    const target = new Date(el.dataset.countdown).getTime();
    if (isNaN(target)) { el.hidden = true; return; }
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      let diff = Math.max(0, target - Date.now());
      if (diff === 0) {
        el.classList.add('is-done');
        el.innerHTML = '<span class="live-dot"></span>&nbsp;' + (el.dataset.done || '');
        clearInterval(timer);
        return;
      }
      const d = Math.floor(diff / 864e5); diff -= d * 864e5;
      const h = Math.floor(diff / 36e5); diff -= h * 36e5;
      const m = Math.floor(diff / 6e4); diff -= m * 6e4;
      const s = Math.floor(diff / 1e3);
      el.querySelector('[data-d]').textContent = pad(d);
      el.querySelector('[data-h]').textContent = pad(h);
      el.querySelector('[data-m]').textContent = pad(m);
      el.querySelector('[data-s]').textContent = pad(s);
    };
    const timer = setInterval(tick, 1000);
    tick();
  });

  /* ---------- Produkt-Galerie ---------- */
  $$('[data-gallery]').forEach((g) => {
    const track = $('[data-gallery-track]', g);
    const thumbs = $$('[data-thumb]', g);
    const dots = $$('.gallery__dots span', g);
    if (!track) return;
    thumbs.forEach((t) => t.addEventListener('click', () => {
      track.scrollTo({ left: track.clientWidth * Number(t.dataset.thumb), behavior: 'smooth' });
    }));
    track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    }, { passive: true });
    // Zoom: auf Desktop großes Bild in neuem Tab, auf Handy wischen statt öffnen
    $$('[data-zoom]', g).forEach((a) => a.addEventListener('click', (e) => { if (window.innerWidth < 750) e.preventDefault(); }));
  });

  /* ---------- Sticky Kaufen-Leiste ---------- */
  const stickyBuy = $('[data-sticky-buy]');
  const buyBox = $('.product__buy');
  if (stickyBuy && buyBox && 'IntersectionObserver' in window) {
    stickyBuy.hidden = false;
    new IntersectionObserver(([entry]) => {
      stickyBuy.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(buyBox);
  }

  /* ---------- Kollektion: Größe / Verfügbar / Sortierung ---------- */
  const coll = $('[data-collection]');
  if (coll) {
    const cards = $$('[data-grid] .card', coll);
    const chips = $$('[data-size-filter]', coll);
    const avail = $('[data-available-filter]', coll);
    const empty = $('[data-filter-empty]', coll);
    const params = new URLSearchParams(window.location.search);
    let size = (params.get('size') || '').toUpperCase();

    const apply = () => {
      let shown = 0;
      cards.forEach((c) => {
        const okSize = !size || (c.dataset.size || '').toUpperCase() === size;
        const okAvail = !(avail && avail.checked) || c.dataset.available === 'true';
        const ok = okSize && okAvail;
        c.classList.toggle('is-filtered', !ok);
        if (ok) shown++;
      });
      chips.forEach((ch) => ch.classList.toggle('is-active', ch.dataset.sizeFilter === size));
      if (empty) empty.hidden = shown !== 0 || cards.length === 0;
      const u = new URL(window.location.href);
      if (size) u.searchParams.set('size', size); else u.searchParams.delete('size');
      history.replaceState(null, '', u);
    };
    chips.forEach((ch) => ch.addEventListener('click', () => { size = ch.dataset.sizeFilter; apply(); }));
    if (avail) avail.addEventListener('change', apply);
    const reset = $('[data-reset-filters]', coll);
    if (reset) reset.addEventListener('click', () => { size = ''; if (avail) avail.checked = false; apply(); });
    const sort = $('[data-sort]', coll);
    if (sort) sort.addEventListener('change', () => {
      const u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
    apply();
  }

  /* ---------- Ähnliche Produkte ---------- */
  const recs = $('[data-recs]');
  if (recs && !recs.children.length && recs.dataset.url) {
    fetch(recs.dataset.url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim()) recs.innerHTML = fresh.innerHTML;
    }).catch(() => {});
  }

  /* ---------- Popup ---------- */
  const popup = $('#Popup');
  function closePopup() {
    if (!popup || popup.hidden) return;
    popup.hidden = true;
    document.body.classList.remove('is-locked');
    store.set('pp_popup', String(Date.now()));
  }
  if (popup) {
    popup.addEventListener('click', (e) => { if (e.target.closest('[data-close-popup]')) closePopup(); });
    const success = popup.querySelector('[data-popup-success]');
    const justPosted = success && (window.location.hash === '#PopupForm' || /customer_posted=true/.test(window.location.search));
    const last = Number(store.get('pp_popup') || 0);
    const days = Number(popup.dataset.days || 14);
    const due = Date.now() - last > days * 864e5;
    const show = () => { popup.hidden = false; document.body.classList.add('is-locked'); };
    if (justPosted) show();
    else if (!success && due && !popup.hasAttribute('data-design-mode')) setTimeout(show, Number(popup.dataset.delay || 8) * 1000);
  }
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.querySelector && e.target.querySelector('#Popup')) { const p = $('#Popup'); if (p) p.hidden = false; }
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.target.querySelector && e.target.querySelector('#Popup')) { const p = $('#Popup'); if (p) p.hidden = true; document.body.classList.remove('is-locked'); }
  });
})();
